<template>
  <div>
    <!-- <headerLoginNoMenu></headerLoginNoMenu> -->
    <div class="confirm-css">
      <div class="row justify-content-center">
        <div class="col-md-7 col-sm-12">
          <div class="card">
            <div class="cartid">
              <div class="row">
                <b-link :to="{ name: 'cart'}">
                  Back
                </b-link>
                <span>Transaction ID - {{this.$route.params.cartId}}</span>
              </div>

            </div>
            <br>
            <div class="row text-center">
              <div class="col-md-6">
                <div class="bal">{{this.amount}}</div>
                <div class="title">{{$t('common.alerts.POINTS_IN_WALLET')}} </div>
              </div>
              <div class="col-md-6">
                <div class="bal"> {{this.total1}} </div>
                <div class="title">{{$t('common.labels.Total_Points_Need_To_Purchase')}}</div>
              </div>
            </div>
            <div class="addmoney">
              <div v-if="amount!= undefined && total1 != undefined && amount != null && total1 != null && amount>=total1" class="text-center">
                <button id='button' @click='paymentGateway()' class="btn btn-blue btn-payment btn-large btn-responsive">Proceed to Payment</button>
              </div>
              <div v-else class="col-10 text-center align-self-center">
                <div class="row">
                  <input type="number" class="form-control col" placeholder="Enter amount to add" v-model="total1">
                  <button @click='addMoney()' class="btn btn-radius btn-blue btn-large ">Add Money</button>
                   <h6>On clicking the "add Money" button you will be redirected to our payment gateway</h6>
                </div>
              </div>


<!--             <div class="addmoney">
              <div v-if="!balance" class="text-center">
                <button id='button' @click='paymentGateway()' class="btn btn-blue btn-large btn-responsive">Proceed to Payment</button>
              </div>
              <div v-else class="col-10 text-center align-self-center">
                <div class="row">
                  <input type="number" class="form-control col" placeholder="Enter amount to add" v-model="amountToAdd">
                  <button @click='addMoney()' class="btn btn-radius btn-blue btn-large ">Add Money</button>
                  <span>On clicking the "Proceed to pay" button you will be redirected to our payment gateway</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray">
      <div class="divider"></div>
      <courseWishlist v-if="$store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length>0"></courseWishlist>
    </div>
    <!-- <footerArea></footerArea> -->
    <form :action=url method="POST" id="upsForm" name="upsForm">
      <input name="upsString" v-model="upsString" type="hidden" id="someId">
      <input name="reqFrom" value="goLang" type="hidden">
    </form>
  </div>
</template>
<script>
import * as cons from '../common/constants.js'
import axios from 'axios'
import Vue from 'vue'
import VueSwal from 'vue-swal'
import footerArea from '../common/footerArea.vue'
// import headerLoginNoMenu from './common/headerLoginNoMenu.vue'
import courseWishlist from '@/components/wishList/courseWishList.vue'
Vue.use(VueSwal)
export default {
  name: 'confirmation',
  components: {
    footerArea,
    courseWishlist
  },
  data () {
    return {
      walletId: '',
      amount: 0,
      balance: false,
      amountToAdd: '',
      upsString: '',
      url: cons.PAYMENT_REQUEST_URL,
      total1: 0
    }
  },
  mounted () {
    this.totalAmountToPay()
  },
  created () {
    this.getWalletAmount()
    /* return new Promise((resolve, reject) => {
      axios
        .post('/r/cartView', {
          profileId: this.$store.getters.getProfileDetails.profileId
        })
        .then(res => {
          if (res.data !== null) {
            if (res.data.items.length !== 0) {
              res.data.items.forEach(element => {
                this.total1 = this.total1 + parseInt(element.amount)
                alert(this.total1)
              })
            }
            // this.$route.params.amount = total1
          }
          resolve()
        })
        .catch(err => {
          console.log('error viewing::', err)
          reject(err)
        })
    }) */
  },
  methods: {
    totalAmountToPay () {
      return new Promise((resolve, reject) => {
        axios
          .post('/r/cartView', {
            profileId: this.$store.getters.getProfileDetails.profileId
          })
          .then(res => {
            if (res.data !== null) {
              if (res.data.items.length !== 0) {
                res.data.items.forEach(element => {
                  this.total1 = this.total1 + parseInt(element.amount)
                  // alert(this.total1)
                  // console.log('to pay', this.total1)
                })
              }
              // this.$route.params.amount = total1
            }
            resolve()
          })
          .catch(err => {
            console.log('error viewing::', err)
            reject(err)
          })
      })
    },
    paymentGateway () {
      // alert(JSON.stringify(this.$store.getters.getCartData))
      document.getElementById('button').disabled = true
      var obj = {}
      return new Promise((resolve, reject) => {
        axios
          .post('r/wallet/paymentRequest', {
            profileId: this.$store.getters.getProfileDetails.profileId,
            totalAmount: this.total1,
            cartId: this.$route.params.cartId,
            items: this.$store.getters.getCartData.items
          })
          .then(res => {
            if (res.data === 0) {
              this.$router.push({ name: 'success', params: { amount: this.$route.params.amount, transactionId: this.$route.params.cartId, status: 'success', payementMode: 'wallet' } })
              obj.cartId = ''
              obj.items = []
              this.$store.commit('clearCartData')
            } else if (res.data === -1) {
              this.$toasted.error('Error In Payment Service')
            } else {
              // alert('Add ' + res.data + ' to your wallet')
              // this.$swal('Dear User', 'Kindly add ' + res.data + ' for purchase.', 'warning')
              this.$toasted.error('Dear User Kindly add ' + res.data + ' Points')
              this.amountToAdd = res.data
              // alert(this.amountToAdd)
              this.balance = true
            }
            resolve()
          })
          .catch(err => {
            console.log('Error in Payment Service', err)
            reject()
          })
        document.getElementById('button').disabled = false
      })
    },
    addMoney () {
      return new Promise((resolve, reject) => {
        axios
          .post('r/wallet/purchaseHistory', {
            profileId: this.$store.getters.getProfileDetails.profileId,
            walletId: this.walletId,
            totalAmount: parseInt(this.total1)
            // totalAmount: parseInt(this.amountToAdd)
          })
          .then(res => {
            if (res.data !== '') {
              this.upsString = res.data
              this.submitUpsForm()
              // this.getWalletAmount()
            } else {
              console.log('Error')
            }
            resolve()
          })
          .catch(err => {
            console.log('Error in Updating wallet Amount', err)
            reject()
          })
      })
    },
    submitUpsForm () {
      // console.log('this.upsString >> ' + this.upsString)
      document.getElementById('someId').value = this.upsString
      document.getElementById('upsForm').submit()
    },
    getWalletAmount () {
      return new Promise((resolve, reject) => {
        axios
          .post('r/wallet/getWalletDetailsbyUser', {
            profileId: this.$store.getters.getProfileDetails.profileId
          })
          .then(res => {
            this.amount = res.data.totalAmount
            this.walletId = res.data.walletId
            resolve(this.amount)
          })
          .catch(err => {
            console.log('ERROR_IN_GETTING_WALLET_AMOUNT : ', err)
            reject()
          })
      })
      // return this.amount
    }
  }
}
</script>

<style lang="scss">
  
@import '../../../static/assets/styles/scss/variables.scss';

.confirm-css {
  padding: 0 15px;
  background: linear-gradient(to bottom, #61bfee 10%, #af96fa 70%,#fff 100%);
    margin-bottom:50px;
  // margin-top:-7px;
  .bg-gray {
    background: linear-gradient(to bottom, #eee 0%, #fff 100%);
  }
  
    .btn-payment:not(:disabled):not(.disabled):active{
      background: #61bfee 10%;
    }
  
  .card {
    .cartid {
      padding-bottom: 20px;
      font-weight: 600;
      font-size: 14px;
      color: #777;
      span {
        display: inline-block;
        margin-left: 20px;
        text-align: center;
      }
    }
    .title {
      font-family: $opensans;
      padding-bottom: 20px;
      padding-top:10px;
      font-weight: 600;
      font-size: 16px;
      display: block;
    }
    .mdi {
      vertical-align: middle;
      font-size: 14px;
      padding-right: 10px;
    }
    .bal {
      .mdi {
        font-size: 24px;
        color: #61bfee; /*non-webkit fallback*/
        background: -webkit-linear-gradient(80deg, #61bfee, #af96fa);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      padding-top: 15px;
      color: #61bfee; /*non-webkit fallback*/
      line-height: 70px;
      font-size: 5rem;
      background: -webkit-linear-gradient(80deg, #61bfee, #af96fa);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin: 80px 0;
    padding: 35px;
    .addmoney {
      margin-top: 40px;
      margin-bottom: 0px;
      .form-control {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        box-shadow: none;
      }
      .btn-radius {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
    }
  }
  @media screen and (max-width:320px){
    .btn-responsive{
      margin-left:-20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cart/confirmation.vue?81a7bbd6